'use strict';

var React = require('react');

var SvgPinUnfilledMajor = function SvgPinUnfilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8.763 6.48-1.108 4.988-1.17.032a.5.5 0 0 0-.485.5v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.485-.5l-1.17-.032-1.108-4.988.999-.539a.5.5 0 0 0 .264-.441v-.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .264.441l1 .539zm4.184.782a2 2 0 0 0 1.053-1.762v-.5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.5a2 2 0 0 0 1.053 1.762l-.609 2.739a2 2 0 0 0-1.944 1.999v.5a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-.5a2 2 0 0 0-1.944-2l-.609-2.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.928 13.265a.75.75 0 0 1 .572-.265h1a.75.75 0 0 1 .74.873l-.5 3a.75.75 0 0 1-1.48 0l-.5-3a.75.75 0 0 1 .168-.608zm-2.178-3.265h2.5a.75.75 0 0 1 0 1.5h-2.5v-1.5z"
  }));
};
SvgPinUnfilledMajor.displayName = "PinUnfilledMajor";

exports.SvgPinUnfilledMajor = SvgPinUnfilledMajor;
